import { render, staticRenderFns } from "./SearchMovement.vue?vue&type=template&id=481c48f6"
import script from "./SearchMovement.vue?vue&type=script&lang=js"
export * from "./SearchMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports